var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrailer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "cluster_trailer_filter",
    width: "192.9%",
    height: "208.3%",
    x: "-46.4%",
    y: "-54.2%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    filter: "url(#cluster_trailer_filter)",
    transform: "matrix(-1 0 0 1 16 1)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.61 8.705H.73a.713.713 0 0 1-.516-.224.783.783 0 0 1-.213-.54v-.422c0-.421.327-.763.729-.763h12.484c.402 0 .729.342.729.763v.422c0 .422-.327.764-.73.764H9.611z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M7.315 9.874c.305 0 .553-.262.553-.584a.596.596 0 0 0-.16-.413.543.543 0 0 0-.393-.172c-.305 0-.553.262-.553.585 0 .154.057.302.161.412.104.11.245.172.392.172zm0 .78c-.712 0-1.289-.611-1.289-1.364 0-.753.577-1.364 1.289-1.364s1.29.61 1.29 1.364c0 .753-.578 1.364-1.29 1.364zm3.974-.824c.306 0 .553-.262.553-.585a.596.596 0 0 0-.16-.412.543.543 0 0 0-.393-.173c-.304 0-.552.262-.552.585 0 .155.057.303.16.412.104.11.245.172.393.173zm0 .78c-.711 0-1.289-.612-1.289-1.365 0-.754.578-1.364 1.29-1.364.712 0 1.289.61 1.289 1.364 0 .753-.578 1.364-1.29 1.364z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M2 7.595v2.562"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M.9.178h12.2c.239 0 .468.1.636.276a.966.966 0 0 1 .264.667v3.876c0 .52-.403.943-.9.943H.9a.88.88 0 0 1-.636-.276A.966.966 0 0 1 0 4.997V1.121C0 .601.403.178.9.178zM8 1.538v3.04c0 .173.112.313.25.313s.25-.14.25-.312v-3.04c0-.173-.112-.314-.25-.314s-.25.14-.25.313zm2 0v3.04c0 .173.112.313.25.313s.25-.14.25-.312v-3.04c0-.173-.112-.314-.25-.314s-.25.14-.25.313zm2 0v3.04c0 .173.112.313.25.313s.25-.14.25-.312v-3.04c0-.173-.112-.314-.25-.314s-.25.14-.25.313zm-10 0v3.04c0 .173.112.313.25.313s.25-.14.25-.312v-3.04c0-.173-.112-.314-.25-.314s-.25.14-.25.313zm2 0v3.04c0 .173.112.313.25.313s.25-.14.25-.312v-3.04c0-.173-.112-.314-.25-.314s-.25.14-.25.313zm2 0v3.04c0 .173.112.313.25.313s.25-.14.25-.312v-3.04c0-.173-.112-.314-.25-.314s-.25.14-.25.313z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailer);
export default __webpack_public_path__ + "static/media/trailer.078be663ae951b48109db427be27d104.svg";
export { ForwardRef as ReactComponent };